import { forEachObjIndexed } from 'ramda';

export const validateForm = (form: any) => ({
  username: !form.username,
  password: !form.password,
});

const getFormData = (data: any) => {
  let formData = '';

  forEachObjIndexed((value, name) => {
    formData += formData
      ? `&${String(name)}=${encodeURIComponent(value)}`
      : `${String(name)}=${encodeURIComponent(value)}`;
  }, data);

  return `${formData}&failure=/failure&success=/success`;
};

export default getFormData;
